import template from './ordinacijaCreateEdit.html';
import swal from 'sweetalert';

class OrdinacijaCreateController {
    constructor(DS, AppConfiguration, $state, logger) {
        this.$state = $state;
        this.logger = logger;
        this.Model = DS.definitions['Ordinacija'];
        this.view = AppConfiguration().getViewByEntityAndType('Ordinacija', 'CreateView');
    }

    $onInit() {
        this.pageTitle = 'Unos nove ordinacije dentalne medicine';
        this.pageDesc = 'Podaci o ordinaciji dentalne medicine';
        this.fields = this.view.fields();
    }

    submit(item) {
        const previousWindowKeyDown = window.onkeydown;
        this.Model.create(item)
            .then((response) => {
                swal({
                        title: 'Zahvaljujemo',
                        text: 'Podaci su uspiješno pohranjeni',
                        type: 'success',
                        closeOnConfirme: true
                    },
                    () => {
                        window.onkeydown = previousWindowKeyDown;
                        this.Model.ejectAll();
                        this.$state.go('ordinacija.details', {id: response.id});
                    });
            })
            .catch((error) => {
                this.logger.error('Upsss', error.data);
            });

    }
}

OrdinacijaCreateController.$inject = ['DS', 'AppConfiguration', '$state', 'logger'];

const OrdinacijaCreateComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: OrdinacijaCreateController,
    controllerAs: 'vm',
    bindings: {
        item: '<'
    }
};

export {OrdinacijaCreateComponent};
export {OrdinacijaCreateController};



// WEBPACK FOOTER //
// ./app/components/ordinacija/ordinacijaCreate.component.js